import { render, staticRenderFns } from "./cud-param-items.vue?vue&type=template&id=9321a2f8&"
import script from "./cud-param-items.vue?vue&type=script&lang=ts&"
export * from "./cud-param-items.vue?vue&type=script&lang=ts&"
import style0 from "./cud-param-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports